module.exports = __webpack_public_path__ + "img/circle-k.c8705102.svg";